import { Injector } from '@angular/core';
import { VisibilityMonitor } from '../utilities/visibility-tracker.service';

/***
 * Starts service responsible for tracking whether the user is currently viewing the screen or has it minimized.
 * @param injector
 */
export const loadVisibilityMonitor = (injector: Injector): Promise<void> => new Promise((resolve) => {
	const monitor = injector.get(VisibilityMonitor);
	monitor.start();
	resolve();
});
